class ClientDataService {
    static $inject = ["$cookies"];

    constructor($cookies) {
        this.$cookies = $cookies;
        this.tokenKey = "tpsr";
    }

    setToken = token => {
        this.$cookies.put(this.tokenKey, token);
    };

    getToken = () => {
        return this.$cookies.get(this.tokenKey);
    };

    removeToken = () => {
        return this.$cookies.remove(this.tokenKey);
    };
}

angular
    .module("app")
    .service("clientDataService", ClientDataService);
